export default __webpack_public_path__ + "static/media/id-number.2d83ba15.svg";